import {_Vue} from 'vue';
import {settings} from "@pazion/pazion-core/src/store";


const convertCamelToCapitalized = (str: string) => {
    const words = str.split(/(?=[A-Z])/);
    const capitalized = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    return capitalized;
}

const convertLabelToPascalCase = (label: string) => {
    return label[0].toUpperCase() + label.slice(1)
        .replace(/-([a-z])/g, (g1) => g1[1].toUpperCase());
}


// use a function to lookup label, visible, required(and use defaults as default / fallback)
// if no label, use the field name(as is now), with start uppercase letter.

export const fieldsByClass = (vm: _Vue, fieldName: string, alias?: string): {
    label: string,
    visible: boolean,
    required: boolean
} | undefined => {

    const className = alias ? alias : convertLabelToPascalCase(vm.$options._componentTag)

    if (!className || !fieldName || !settings) {
        return {
            label: convertCamelToCapitalized(fieldName),
            visible: true,
            required: false
        }
    }

    if (settings && settings.hasOwnProperty('fieldDefinitions') && settings.fieldDefinitions) {

        const currentFields = settings.fieldDefinitions[className]
        const hasDefinition = currentFields.fields[fieldName];
        const currentField = hasDefinition ? hasDefinition : currentFields.defaults

        let label;
        let visible;
        let required;

        if (!hasDefinition) {
            label = convertCamelToCapitalized(fieldName);
            visible = currentField.visible;
            required = currentField.required;
        } else {
            label = currentField.label ? currentField.label : convertCamelToCapitalized(fieldName);
            visible = currentField.visible;
            required = currentField.required;
        }
        return {
            label,
            visible,
            required
        }
    }
}